module.exports = __webpack_public_path__ + "img/unknown_intent_icon.2bab4318.svg";